<div class="w-full h-full">
    <div class="grid grid-cols-12 gap-3">
        <div class="col-span-12">
            <div class="text-m text-black font-bold uppercase text-center">
                KYC Details
            </div>
        </div>
        <div class="col-span-12">
            <hr class="border border-gray-300 w-full ">
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-60-px font-semibold">
                    Name:
                </span>
                <div class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    {{firstName | nullWithDefault | titlecase }}&nbsp;{{middleName  | titlecase}}&nbsp;{{lastName  | titlecase}}
                </div>
            </div>
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-140-px font-semibold">
                    Phone Number:
                </span>
                <div class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    {{userName  | nullWithDefault}}
                </div>
            </div>
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-70-px font-semibold">
                    Address:
                </span>
                <div class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    {{address  | nullWithDefault |titlecase  }}
                </div>
            </div>
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-40-px font-semibold">
                    City:
                </span>
                <div class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    {{city  | nullWithDefault  |titlecase  }}
                </div>
            </div>
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-70-px font-semibold">
                    Province:
                </span>
                <div class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    {{province  | nullWithDefault   |titlecase  }}
                </div>
            </div>
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-90-px font-semibold">
                    Zip Code
                </span>
                <div class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    {{zipCode  | nullWithDefault}}
                </div>
            </div>
        </div>
        <div class="col-span-4">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-418-px font-semibold">
                    Birth Date (yyyy-mm-dd): 
                </span>
                <div *ngIf="year || month || day" class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    {{ year }}&nbsp;- {{ month | number : '2.0-0' }}&nbsp;-{{ day | number : '2.0-0' }}
                </div>
                <div *ngIf="!year || !month || !day" class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    N / A
                </div>
            </div>
        </div>
        <div class="col-span-4">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-120-px font-semibold">
                    Birth Place:
                </span>
                <div class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    {{birthPlace  | nullWithDefault  |titlecase }}
                </div>
            </div>
        </div>
        <div class="col-span-4">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-140-px font-semibold">
                    Email Verified:
                </span>
                <div class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    {{emailVerified_text | nullWithDefault}}
                </div>
            </div>
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-100-px font-semibold">
                    Civil Status:
                </span>
                <div class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    {{civilStatus_text  | nullWithDefault }}
                </div>
            </div>
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-100-px font-semibold">
                    Nationality:
                </span>
                <div class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    {{nationality  | nullWithDefault }}
                </div>
            </div>
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-190-px font-semibold">
                    Employment Status:
                </span>
                <div class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    {{employmentStatus  | nullWithDefault }}
                </div>
            </div>
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-150-px font-semibold">
                    Source of Fund:
                </span>
                <div class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    {{sourceOfFund  | nullWithDefault }}
                </div>
            </div>
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-50-px font-semibold">
                    Status:
                </span>
                <div class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    {{status_text | nullWithDefault}}
                </div>
            </div>
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-30-px font-semibold">
                    Tier:
                </span>
                <div class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    {{tierType_text | nullWithDefault}}
                </div>
            </div>
        </div>
        
        <!-- Selfie Image -->
        <div class="col-span-6 mb-3">
            <div class="pl-2 flex flex-col">
                <div class="flex items-center justify-between mb-1">
                    <div class="text-xs font-semibold">Selfie Image</div>
                    <div class="flex gap-1" *ngIf="imageSelfieUrl">
                        <a [href]="imageSelfieUrl"
                            download
                            class="flex items-center gap-1 text-xs px-2 py-1 rounded cursor-pointer transition-all"
                            [style.background-color]="isHoveredSelfieDownload ? '#E1742E' : '#FCF2EB'"
                            [style.color]="isHoveredSelfieDownload ? '#ffffff' : '#E1742E'"
                            (mouseover)="isHoveredSelfieDownload = true"
                            (mouseleave)="isHoveredSelfieDownload = false">
                                <span class="material-icons text-sm">download</span>
                                Download
                        </a>
                        
                        <button (click)="viewImageInNewTab(imageSelfieUrl)"
                                class="flex items-center gap-1 text-xs px-2 py-1 rounded cursor-pointer transition-all"
                                [style.background-color]="isHoveredSelfieView ? '#E1742E' : '#FCF2EB'"
                                [style.color]="isHoveredSelfieView ? '#ffffff' : '#E1742E'"
                                (mouseover)="isHoveredSelfieView = true"
                                (mouseleave)="isHoveredSelfieView = false">
                            <span class="material-icons text-sm">open_in_new</span>
                            View
                        </button>
                    </div>
                </div>
                
                <div class="flex flex-col items-center justify-center mt-6 mx-auto w-fit max-w-xs">
                    <img [src]="imageSelfieUrl"
                        class="object-contain cursor-pointer hover:opacity-80 transition-opacity max-w-full max-h-64 border-2 border-gray-300 rounded"
                        (click)="openImagePreview(imageSelfieUrl, 'Selfie Image')"
                        *ngIf="imageSelfieUrl">
                    <div class="py-12 text-center text-xs italic border-2 border-gray-300 w-220-px h-190-px flex items-center justify-center" 
                        *ngIf="!imageSelfieUrl">
                        N / A
                    </div>
                </div>
            </div>
        </div>
        
        <!-- ID Image-->
        <div class="col-span-6 mb-10">
            <div class="pl-2 flex flex-col">
                <div class="flex items-center justify-between mb-1">
                    <div class="text-xs font-semibold">ID Image</div>
                    <div class="flex gap-1" *ngIf="imageIdUrl">
                        <a [href]="imageIdUrl"
                            download
                            class="flex items-center gap-1 text-xs px-2 py-1 rounded cursor-pointer transition-all"
                            [style.background-color]="isHoveredIdDownload ? '#E1742E' : '#FCF2EB'"
                            [style.color]="isHoveredIdDownload ? '#ffffff' : '#E1742E'"
                            (mouseover)="isHoveredIdDownload = true"
                            (mouseleave)="isHoveredIdDownload = false">
                                <span class="material-icons text-sm">download</span>
                                Download
                        </a>
                        <button (click)="viewImageInNewTab(imageIdUrl)"
                                class="flex items-center gap-1 text-xs px-2 py-1 rounded cursor-pointer transition-all"
                                [style.background-color]="isHoveredIdView ? '#E1742E' : '#FCF2EB'"
                                [style.color]="isHoveredIdView ? '#ffffff' : '#E1742E'"
                                (mouseover)="isHoveredIdView = true"
                                (mouseleave)="isHoveredIdView = false">
                            <span class="material-icons text-sm">open_in_new</span>
                            View
                        </button>
                    </div>
                </div>
                <div class="flex flex-col items-center justify-center mt-6 mx-auto w-fit max-w-xs">
                    <img [src]="imageIdUrl"
                        class="object-contain cursor-pointer hover:opacity-80 transition-opacity max-w-full max-h-64 border-2 border-gray-300 rounded"
                        (click)="openImagePreview(imageIdUrl, 'ID Image')"
                        *ngIf="imageIdUrl">
                    <div class="py-12 text-center text-xs italic border-2 border-gray-300 w-220-px h-190-px flex items-center justify-center" 
                        *ngIf="!imageIdUrl">
                        N / A
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>